import { createContext, useContext, useEffect, useMemo, useState } from "react";

import { api } from "@/lib/api";


const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadSession = async () => {
      try {
        const response = await api.get("/auth/me");
        setUser(response.data);
      } catch {
        setUser(false);
      } finally {
        setIsLoading(false);
      }
    };

    loadSession();
  }, []);

  useEffect(() => {
    const expireSession = () => setUser(false);

    window.addEventListener("aneka-auth-expired", expireSession);
    return () => window.removeEventListener("aneka-auth-expired", expireSession);
  }, []);

  const value = useMemo(() => ({
    user,
    isLoading,
    setUser,
  }), [user, isLoading]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth harus digunakan di dalam AuthProvider.");
  }

  return context;
};